import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, MultiCombo } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'
import * as API from 'modules/app/API'

const items = {
	"1": "Ford",
	"2": "BMW",
	"3": "Porsche",
	"4": "Mercedes",
	"5": "VW",
	"6": "Ferrari",
	"7": "Peugeot",
	"8": "Lamborgini",
	"9": "Renault",
	"10": "Toyota"
};

class MultiComboDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			roles: [],
			roleUsers: [],
			form: {
				presetIds: "2, 3"
				// presetIds: [2, 3] <- this is also valid
			}
		};
	}

	componentDidMount() {
		this.loadRoles();
	}

	loadRoles = () => {
		const self = this;

		API.Security.get('/query/getRoles', {},
			{
				success: function (response) {
					self.setState({
						roles: response.data.items.map((item) => { return { label: item.roleName, value: item.roleId } })
					});
				}
			});
	}

	loadRoleUsers = () => {
		const self = this;

		API.Security.get('/query/getRoleUsers', { roleId: this.state.form.roleId },
			{
				success: function (response) {
					self.setState({
						roleUsers: response.data.items.map((item) => {
							return {
								label: item.fullName,
								value: item.userId
							}
						})
					});
				}
			},
			{
				block: false
			});
	}

	onChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	onRoleChange = (item) => {
		this.loadRoleUsers();
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="MultiCombo">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
                            <Label>Default</Label>
                            <MultiCombo name="multicomboIds" items={items} />
						</Col>
						<Col md={4}>
							<Label>Placeholder</Label>
							<MultiCombo name="placeholderIds" placeholder="ALL" items={items} />
						</Col>
						<Col md={4}>
							<Label>Disabled</Label>
							<MultiCombo name="disabledIds" disabled={true} items={items} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label>Preset</Label>
							<MultiCombo name="presetIds" items={items} />
						</Col>
						<Col md={4}>
							<Label required>Required</Label>
							<MultiCombo name="requiredIds" items={items} required />
						</Col>
						<Col md={4}>
							<Label>Non-Searchable</Label>
							<MultiCombo name="nonSearchableIds" items={items} searchable={false} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label>Clearable</Label>
							<MultiCombo name="clearableIds" items={items} clearable={true} />
						</Col>
						<Col md={4}>
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default MultiComboDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DropDowns/MulticomboDemo.js